module.exports = __webpack_public_path__ + "img/add-simple.518deaf5.svg";